// Tencent LI 账号迁移
import http from '@/lib/axios';

/**
 * 龙之谷2 账号迁移
 */
export async function transferDN2Account(params) {
    return http.post('web/specificEvent/dn2wodMigrate', params);
}

/**
 * 龙之谷2 账号迁移状态查询
 * @return {Promise<{ isMigrated: boolean }>} 1 已迁移，0 未迁移
 */
export async function getDN2TransferStatus(params) {
    return http.post('web/specificEvent/queryDn2wodMigrateStatus', params);
}
